import React, { useEffect, useState } from "react";
import "./styles.scss";
import { FiArrowLeft } from "react-icons/fi";
import InvoiceTemplate from "./invoice-template";
import IndividualInvoiceFieldForm from "./individual-invoice-field-form";
import OrganizationInvoiceFieldForm from "./organization-invoice-field-form";
import { alertActions, commonActions } from "../../_actions";
import { invoiceCreationService } from "../../_services/invoiceCreation.service";
import { appConstants } from "../../_constants";
import { connect } from "react-redux";
import moment from "moment";

const FaanInitiateInvoice = (props) => {
  const entityType = sessionStorage.getItem("entityType");
  const [invoiceTableData, setInvoiceTableData] = useState(null);
  const [invoiceCustomerData, setInvoiceCustomerData] = useState({
    invoiceDate: moment().format("YYYY-MM-DD"),
    // TODO: remove the hardcoded values for individual - customerAIN
    ...(entityType === "individual" && { customerAIN: "1030000001" }),
  });
  const [isAgencyIdReady, setIsAgencyIdReady] = useState(false);
  const [isFetchingServices, setIsFetchingServices] = useState(true);
  const [selfServiceTypes, setSelfServiceTypes] = useState([]);
  const { agencyId, dispatch, user } = props;
  const agencyDomain = window.location.origin;

  useEffect(() => {
    const payload = {
      domainURL: agencyDomain,
      agencyId: "",
      agencyCode: "",
    };
    dispatch(commonActions.getBranding(payload));
  }, [agencyDomain, dispatch]);

  useEffect(() => {
    if (agencyId && !isAgencyIdReady) {
      setIsAgencyIdReady(true);
      if (entityType === "organization") {
        fetchOrganizationSelfServiceTypes();
      } else {
        fetchIndividualsSelfServiceTypes();
      }
    }
  }, [agencyId, isAgencyIdReady]);

  const fetchIndividualsSelfServiceTypes = () => {
    // TODO: remove the hardcoded values - agencyId
    // let payload = { agencyId: agencyId };
    let payload = { agencyId: 10 };
    dispatch(alertActions.startRequest());
    invoiceCreationService
      .getIndividualsSelfServiceTypes(payload)
      .then((res) => {
        setIsFetchingServices(false);
        dispatch(alertActions.stopRequest());
        let response = res.response;
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          const uniqueData =
            [
              ...new Set(response?.data?.map((item) => JSON.stringify(item))),
            ].map((item) => JSON.parse(item)) || [];
          setSelfServiceTypes(uniqueData);
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
        }
      });
  };

  const fetchOrganizationSelfServiceTypes = () => {
    let payload = { agencyId: user?.organizationId };
    dispatch(alertActions.startRequest());
    invoiceCreationService
      .getOrganizationSelfServiceTypes(payload)
      .then((res) => {
        setIsFetchingServices(false);
        dispatch(alertActions.stopRequest());
        let response = res.response;

        if (res.status === appConstants.SUCCESS_RESPONSE) {
          const uniqueData =
            [
              ...new Set(response?.data?.map((item) => JSON.stringify(item))),
            ].map((item) => JSON.parse(item)) || [];
          setSelfServiceTypes(uniqueData);
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
        }
      });
  };

  const handleBack = () => {
    if (entityType === "organization") {
      commonActions.logOut();
      // This will help in seting the stage for organization users when going back 
      sessionStorage.setItem("cameBack", "true");
    }
    if (entityType === "individual") {
      sessionStorage.removeItem("entityType");
    }
    window.location.replace("/invoice-creation");
  };

  useEffect(() => {
    if (
      entityType === "organization" &&
      sessionStorage.getItem("selectedOrganization")
    ) {
      setInvoiceCustomerData((prevState) => {
        return {
          ...prevState,
          ...JSON.parse(sessionStorage.getItem("selectedOrganization")),
        };
      });
    }
  }, []);

  return (
    <div className="faan-payment-container">
      <div className="invoice-initiation-content">
        <button onClick={handleBack} className="go-back-button">
          <FiArrowLeft className="icon" />
          <span>Go Back</span>
        </button>
        <div className="invoice-creation-display">
          {entityType === "organization" ? (
            <OrganizationInvoiceFieldForm
              invoiceTableData={invoiceTableData}
              setInvoiceTableData={setInvoiceTableData}
              invoiceCustomerData={invoiceCustomerData}
              isFetchingServices={isFetchingServices}
              organizationSelfServiceTypes={selfServiceTypes}
            />
          ) : (
            <IndividualInvoiceFieldForm
              invoiceTableData={invoiceTableData}
              setInvoiceTableData={setInvoiceTableData}
              invoiceCustomerData={invoiceCustomerData}
              setInvoiceCustomerData={setInvoiceCustomerData}
              individualsSelfServiceTypes={selfServiceTypes}
              isFetchingServices={isFetchingServices}
            />
          )}

          <div className="template-container">
            <InvoiceTemplate
              invoiceTableData={invoiceTableData}
              customerEmail={invoiceCustomerData?.email}
              location={invoiceCustomerData?.address}
              customerPhoneNumber={invoiceCustomerData?.phone}
              customerName={invoiceCustomerData?.customerName}
              customerNumber={invoiceCustomerData?.customerAIN}
              invoiceDate={invoiceCustomerData?.invoiceDate}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  const {
    alert,
    user,
    requesting,
    userData,
    displayGeneralAlert,
    branding,
    agencyId,
  } = state;
  return {
    alert,
    user,
    requesting,
    userData,
    displayGeneralAlert,
    branding,
    agencyId: state.agency ? state.agency.agencyId : null,
  };
}

export default connect(mapStateToProps)(FaanInitiateInvoice);
